var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category',{attrs:{"name":"TP & Velocity","categorystyle":"teleportation_category"}},[_c('block',{attrs:{"type":"teleport_player"}}),_c('block',{attrs:{"type":"go_to_house_spawn"}}),_c('block',{attrs:{"type":"send_to_lobby"}}),_c('block',{attrs:{"type":"change_velocity"}}),_c('block',{attrs:{"type":"launch_to_target"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }